import React, { useState, useEffect } from 'react';
import { Accordion, AccordionBody } from '../common/Accordion';
import { getCountries, getSchools, getCurriculums, getAdmissionMode, getCities, getCountryCode,getCourses, getStudyCenter, getClasses,getCountriesNewList } from '../../actions/RegisterActions'
import { updateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';
import Select from 'react-select';
import { countryId } from '../../config/Constant';


const EnrollmentDetail = (props) => {
    const detail = props.detail

    const [country, setCountry] = useState({ name: 'country', value:{}, error: '', options: [], isRequired: true });
    const [cities, setCities] = useState({ name: 'city', value: '', error: '', options: [], isRequired: false });
    const [otherCityName, setOtherCityName] = useState({ name: 'otherCityName', value: '', error: '', options: [], isRequired: true });
    const [schools, setSchools] = useState({ name: 'schools', value: '', error: '', options: [], isRequired: true });
    const [mobileNumber, setMobile] = useState({ name: 'mobileNumber', value: '', error: '', options: [], isRequired: true });
    const [curriculums, setCurriculums] = useState({ name: 'curriculums', value:'', error: '', options: [], isRequired: true });
    const [classes, setClasses] = useState({ value: '', error: '', options: [], isRequired: false });
    const [center, setCenter] = useState({ value: '', error: '', options: [], isRequired: false });
    const [course, setCourse] = useState({ value: '', error: '', options: [], isRequired: false });
    const [countryCode, setCountryCode] = useState({ name: 'countryCode', value: '', error: '', isRequired: false });
    const [email, setEmail] = useState({ value: '', error: '', options: [], isRequired: false });
    const [admissionMode, setAdmissionMode] = useState({name:'admissionMode', value: '', error: '', options: [], isRequired: false });
    const [otherSchoolName, setOtherSchoolName] = useState({ value: '', error: '', options: [], isRequired: false });
    const [editDetail, setEditDetail] = useState(false);
    const [isOtherCity, setOtherCity] = useState(false)
    const [isOtherSchool, setIsOtherSchool] = useState(false)
    const [admitCard,setAdmitCard] = useState({ value: '', error: '' })

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const detail = props.detail
        if (detail !== undefined) {
            setMobile({ ...mobileNumber, value: detail.mobile_no })
            setEmail({ ...email, value: detail.email })
            setCountryCode({ ...countryCode, value: detail.country_code })
            setOtherCityName({ ...otherCityName, value: detail.other_city!==null?detail.other_city:'' })
            setOtherSchoolName({ ...otherSchoolName, value: detail.other_school })
            setOtherCity(false)
            setIsOtherSchool(false)
        }
        getAdmissionMode()
        .then((res) => {
            setAdmissionMode({ ...admissionMode, options: res.data, })
        });

        getCurriculums()
            .then((res) => {
                setCurriculums({ ...curriculums, options: res.data, })
        });

    }, [detail.mobile_no, detail.country_code, detail.other_city, detail.other_school, detail.admission_mode_id,detail.curriculums])

    useEffect(async () => {
        const detail = props.detail !== undefined && props.detail
        if (detail !== undefined) {

            if(detail.country_id==3){
                const countryRes = await getCountriesNewList();
                setCountry({ ...country, options: countryRes.data.filter(i=>i.id==detail.country_id)[0], 
                value:detail.country_id!==undefined?countryRes.data.filter(i=>i.id==detail.country_id)[0]:{}
            })
            }

            else{
                const countryRes = await getCountries();
            setCountry({ ...country, options: countryRes.data, 
                value:detail.country_id!==undefined?countryRes.data.filter(i=>i.id==detail.country_id)[0]:{}
            })

            }
            
            // const countryRes = await getCountries();
            // setCountry({ ...country, options: countryRes.data, 
            //     value:detail.country_id!==undefined?countryRes.data.filter(i=>i.id==detail.country_id)[0]:{}
            //  })

            const citiesRes = await getCities(detail.country_id)
            setCities({ ...cities, options: citiesRes.data, value:detail.city_id!==undefined?citiesRes.data.filter(i=>i.id==detail.city_id)[0]:{} })

            if (detail.city_id == 0) {
                setOtherCity(true)
            }

            const schoolRes = await getSchools(detail.country_id)
            setSchools({ ...schools, options: schoolRes.data, value:detail.school_id!==undefined?schoolRes.data.filter(i=>i.id==detail.school_id)[0]:{} })

            if(detail.school_id == 0){
                setIsOtherSchool(true)
            }

            const curriculumsRes = await getCurriculums(detail.country_id)
            setCurriculums({ ...curriculums, options: curriculumsRes.data, value:detail.curriculums_id!==undefined?curriculumsRes.data.filter(i=>i.id==detail.curriculums_id)[0]:{} })

            const classesRes = await getClasses(detail.country_id)
            setClasses({ ...classes, options: classesRes.data, value:detail.class_id!==undefined?classesRes.data.filter(i=>i.id==detail.class_id)[0]:{} })

            // const centerRes = await getStudyCenter(detail.country_id)
            // setCenter({ ...center, options: centerRes.data, value: detail.center_id })

            const centerRes = await getStudyCenter(detail.country_id)
            setCenter({ ...center, options: centerRes.data, value:detail.center_id!==undefined?centerRes.data.filter(i=>i.id==detail.center_id)[0]:{} })

            const courseRes = await getCourses(detail.country_id, detail.class_id, detail.center_id)
            setCourse({ ...course, options: courseRes.data, value: detail.course_id!==undefined?courseRes.data.filter(i=>i.id==detail.course_id)[0]:{} })

            const countryCodeRes = await getCountryCode(detail.country_id)
            setCountryCode({ ...countryCode, options: countryCodeRes.data, value: detail.country_code })

            const adminssionModeRes =  await getAdmissionMode();
            setAdmissionMode({ ...admissionMode, options: adminssionModeRes.data, value: detail.admission_mode_id!==null?adminssionModeRes.data.filter(i=>i.id==detail.admission_mode_id)[0]:adminssionModeRes.data.filter(i=>i.id==3)[0] })
            
        }

    }, [detail.country_id,  detail.school_id, detail.country_code, detail.curriculums_id, detail.city_id, detail.class_id, detail.center_id, detail.course_id,detail.admission_mode_id])

    const editPersonalDetail = () => {
        setEditDetail(true)
    }

    const handleCancel = () => {
        setEditDetail(false)
    }

    const handleCountryChange = async (e) => {
        setCountry({ ...country, value: e, error: '' });

        const citiesRes = await getCities(e.id)
        setCities({ ...cities, options:citiesRes.data,value:citiesRes.data.length==1?citiesRes.data[0]:''})
        setOtherCity(false)
        setOtherCityName({...otherCityName,error:''})

        getSchools(e.id)
        .then((res) => {
            setSchools({ ...schools, options:res.data,value:res.data.length==1?res.data[0]:''})
        });

        const centerRes = await getStudyCenter(e.id)
        setCenter({ ...center, options: centerRes.data,value:centerRes.data?.length==1?centerRes.data[0]:''})

        setCourse({ ...course,value:''})
            if(centerRes!==undefined && centerRes.data.length==1){
                const courseRes=await getCourses(e.id,classes.value.id,centerRes.data[0].id)
            setCourse({ ...course, options: courseRes.data,value:courseRes.data?.length==1?courseRes.data[0]:''})
        }

        getCountryCode(e.id)
            .then((res) => {
                setCountryCode({ ...countryCode, options: res.data, value: res.data.isd_code })
        });
    }

    
    const handleCityChange = (e) => {
        const cVal = e.id
        setCities({ ...cities, value: e, error: '' })
        setOtherCityName({ ...otherCityName, value: '', error: '' })
        if (cVal == 0) {
            setOtherCity(true)
        }
        else {
            setOtherCity(false)
        }

    }

    const handleSchoolChange = (e) => {
        const sVal = e.id
        setSchools({ ...schools, value: e, error: '' });
        setOtherSchoolName({ ...otherSchoolName, value: '', error: '' })
        if (sVal == 0) {
            setIsOtherSchool(true)
        }
        else {
            setIsOtherSchool(false)
        }

    }

    const handleCurriculumChange = (e) => {
        setCurriculums({ ...curriculums, value: e, error: '' })
    }

    const handleAdmissionModeChange = (e) => {
        setAdmissionMode({ ...admissionMode, value: e, error:'' });
    }

      const handleClassChange = (e) => {
        setClasses({ ...classes, value: e, error: '' });
        getCourses(country.value.id,e.id,center.value.id)
        .then((res) => {
            setCourse({ ...course, options: res.data,value:res.data?.length==1?res.data[0]:''   })
        });
    }
    
      const handleCenterChange = (e) => {
        setCenter({ ...center, value: e, error: '' })
        getCourses(country.value.id, classes.value.id, e.id)
        .then((res) => {
            setCourse({ ...course, options:res.data,value:res.data?.length==1?res.data[0]:'' })
        });
      }
    
      const handleCourseChange = (e) => {
        setCourse({ ...course, value: e, error:'' })
      }

    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/ ;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true
        if (!country.value) {
            formIsValid = false
            let msg = "Please select country"
            setCountry({ ...country, error: msg })
        }

        if(!schools.value){
            formIsValid = false
            let msg = "Please select school"
            setSchools({...schools,error:msg})
        }
        if(!classes.value){
            formIsValid = false
            let msg = "Please select class"
            setClasses({...classes,error:msg})
        }
        if(!center.value){
            formIsValid = false
            let msg = "Please select study center"
            setCenter({...center,error:msg})
        }
        if(!course.value){
            formIsValid = false
            let msg = "Please select course"
            setCourse({...course,error:msg})
        }
        if(!admissionMode.value){
            formIsValid = false
            let msg = "Please select admission mode"
            setAdmissionMode({...course,error:msg})
        }
        if(!cities.value){
            formIsValid = false
            let msg = "Please select city"
            setCities({...cities,error:msg})
        }

        if (cities.value.id==0) {
            formIsValid = true
            setCities({ ...cities, error: '' })
                if(!otherCityName.value){
                    formIsValid = false
                    setOtherCityName({...otherCityName,error:'Please provide other city name'})
                }
                if (otherCityName.value!=='' && otherCityName.value.length < 3) {
                    formIsValid = false
                    let msg = "Min 3 Character Length"
                    setOtherCityName({ ...otherCityName, error: msg })
                }
                else if (otherCityName.value !=='' && otherCityName.value.length >= 50) {
                    formIsValid = false
                    let msg = "Max 50 Character Length"
                    setOtherCityName({ ...otherCityName, error: msg })
                }
        }

         // Other City
       
        
        // School
        if (schools.value.id==0) {
            formIsValid = true
            setSchools({ ...schools, error: '' })
                if(!otherSchoolName.value){
                    formIsValid = false
                    setOtherSchoolName({...otherSchoolName,error:'Please provide other school name'})
                }

                 // Other school
            if (otherSchoolName.value !== '' && otherSchoolName.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
            else if (otherSchoolName.value !== '' && otherSchoolName.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
        }

        


        if (!curriculums.value) {
            formIsValid = false
            let msg = "Please select school curriculum"
            setCurriculums({ ...curriculums, error: msg })
        }


        // Phone number
            if (!mobileNumber.value) {
                formIsValid = false
                let msg = "Please enter your mobile number"
                setMobile({...mobileNumber,error:msg})  
            }
            if(country.value.id ===1 || country.value.id ===2 || country.value.id ===4 || country.value.id ===5){
                if(mobileNumber.value.length < 8){
                    formIsValid = false
                    let msg = "Min 8 Digit Length"
                    setMobile({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 8){
                    formIsValid = false
                    let msg = "Max 8 Digit Length"
                    setMobile({ ...mobileNumber, error: msg })
                }
            }
            else if(country.value.id ===6){
                if(mobileNumber.value.length < 9){
                    formIsValid = false
                    let msg = "Min 9 Digit Length"
                    setMobile({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 9){
                    formIsValid = false
                    let msg = "Max 9 Digit Length"
                    setMobile({ ...mobileNumber, error: msg })
                }
            }
    
            else if(country.value.id ===7){
                if(mobileNumber.value.length < 9){
                    formIsValid = false
                    let msg = "Min 9 Digit Length"
                    setMobile({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 10){
                    formIsValid = false
                    let msg = "Max 10 Digit Length"
                    setMobile({ ...mobileNumber, error: msg })
                }
            }
    
            if (!mobileRegex.test(mobileNumber.value)) {
                formIsValid = false
                let msg = "Enter a valid Mobile Number"
                setMobile({ ...mobileNumber, error: msg })
            }
    


        if (formIsValid) {
            setMobile({ ...mobileNumber, error: '' })
            setSchools({ ...schools, error: '' })
            setCurriculums({ ...curriculums, error: '' })
            setCities({ ...cities, error: '' })
            setAdmissionMode({...admissionMode, error : ''})
            setClasses({...classes,error:''})
            setCenter({...center,error:''})
            setCourse({...course,error:''})  
            setOtherCityName({ ...otherCityName, error: '' })
            setOtherSchoolName({ ...otherSchoolName, error: '' })
        }

        return formIsValid;

    }

    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     console.log('Uploaded file:', file);
    //     setAdmitCard({ value: file, error: '' });
    // };


    const onSubmit = async (e) => {
        e.preventDefault();
        
        if (validation()) {
            setLoading(true)
            const data = {
                mobile_no: mobileNumber.value,
                country_id: country.value.id,
                email: email.value,
                curriculums_id: curriculums.value.id,
                city_id: cities.value.id,
                center_id: center.value.id,
                class_id: classes.value.id,
                course_id: course.value.id,
                country_code: countryCode.value,
                admission_mode_id : admissionMode.value.id,
                school_id: schools.value.id,
                other_city: otherCityName.value ? otherCityName.value : '',
                other_school: otherSchoolName.value ? otherSchoolName.value : '',
                admit_card:admitCard.value,
            }
            data.id = detail.id

            // const formData = new FormData();
            // formData.append('mobile_no', mobileNumber.value);
            // formData.append('country_id', country.value.id);
            // formData.append('email', email.value);
            // formData.append('curriculums_id', curriculums.value.id);
            // formData.append('city_id', cities.value.id);
            // formData.append('center_id', center.value.id);
            // formData.append('class_id', classes.value.id);
            // formData.append('course_id', course.value.id);
            // formData.append('country_code', countryCode.value);
            // formData.append('admission_mode_id', admissionMode.value.id);
            // formData.append('school_id', schools.value.id);
            // formData.append('other_city', otherCityName.value || '');
            // formData.append('other_school', otherSchoolName.value || '');
            // formData.append('admit_card', admitCard.value); 
            // formData.append('id', detail.id);

            await updateProfileDetail(data).then(res => {
                if (res.status) {
                    setEditDetail(false)
                    setLoading(false)
                    swal('Data updated successfully', '', 'success')
                    props.onSubmit(res)
                }
                else {
                    swal('Something went wrong', '', 'error')
                    setLoading(false)
                }
            })

            .catch(err => {
                console.log(err);
            })
        }

    }
   

  
    return (
        <>
            <Accordion title="Enrollment Details" overflow="overflow-visible" collapseName="enrollmentDetail">
                <AccordionBody>
                    <form  className='hold_mandatoryField edit_enableForm enrollment_formWrap' encType='multipart/form-data'>
                        <div className="row mb-4">
                            <div className="col-lg-12 mb-3">
                                <div className="form-floatings">
                                    <label className="mb-2 text-muted">Country</label>
                                    <Select
                                    className='search-select-dropdown'
                                    name="country"
                                    value={country.value!==null?country.value:''}
                                    isDisabled={detail.is_paid ==1 || !editDetail}
                                    placeholder="Select Country..."
                                    options={country.options}
                                    onChange={handleCountryChange}
                                    getOptionLabel={x => x.name}
                                    getOptionValue={x => x.id}
                                    />

                                </div>
                                {country.error.length > 0 && <div className='invalidFeedback'>{country.error}</div>}

                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floatings ">
                                    <label className="mb-2 text-muted">City</label>
                                    <Select
                                        className='search-select-dropdown'
                                        name="city"
                                        value={cities.value!==null?cities.value:''}
                                        isDisabled={detail.is_paid ==1 || !editDetail}
                                        placeholder={`${country.value.id!==undefined &&country.value.id === countryId.UAE  ? "Select Emirates..." :'Select City...'}`}
                                        options={cities.options}
                                        onChange={handleCityChange}
                                        getOptionLabel={x => x.name}
                                        getOptionValue={x => x.id}
                                    />
                                </div>
                                {cities.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{cities.error}</div>}
                            </div>
                            {isOtherCity || cities.value == 0 ? 
                            <div className="col-lg-6 mb-3 mt-1">
                                <div className="form-floating diff_disable mt-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="otherCityName"
                                        placeholder={`${country.value &&country.value == countryId.UAE  ? "Other emirates name" :'Other city name'}`}
                                        value={otherCityName.value!==null ? otherCityName.value:''}
                                        disabled={detail.is_paid ==1 || !isOtherCity || !editDetail}
                                        onChange={(e) => setOtherCityName({ ...otherCityName, value: e.target.value, error: '' })}
                                    />
                                    <label className={!isOtherCity ? 'optional':''}>{country.value &&country.value == countryId.UAE  ? "Other emirates name" :'Other city name'}</label>
                                </div>
                                {otherCityName.error.length > 0 && <div className='invalidFeedback'>{otherCityName.error}</div>}
                            </div>
                           :'' }

                            <div className="col-lg-6 mb-3">
                                <div className="form-floatings">
                                    <label className="mb-2 text-muted">Class</label>
                                    <Select
                                    className='search-select-dropdown'
                                    name="classes"
                                    value={classes.value!==null?classes.value:''}
                                    isDisabled={detail.is_paid ==1 || !editDetail}
                                    placeholder='Select Classes...'
                                    options={classes.options}
                                    onChange={handleClassChange}
                                    getOptionLabel={x => x.name}
                                    getOptionValue={x => x.id}
                                    />
                                    {/* <label htmlFor="floatingInput">Class</label> */}
                                </div>
                                {classes.error.length>0 &&<div className='invalidFeedback'>{classes.error}</div>}
                                </div>

                                <div className="col-lg-6 mb-3">
                                <div className="form-floatings">
                                <label className="mb-2 text-muted">Study Center</label>
                                    <Select
                                    className='search-select-dropdown'
                                    name="center"
                                    value={center.value!==null?center.value:''}
                                    isDisabled={detail.is_paid ==1 || !editDetail}
                                    placeholder='Select Study Center...'
                                    options={center.options}
                                    onChange={handleCenterChange}
                                    getOptionLabel={x => x.name}
                                    getOptionValue={x => x.id}
                                    />
                                    
                                </div>
                                {center.error.length>0 &&<div className='invalidFeedback'>{center.error}</div>}
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <div className="form-floatings">
                                        <label className="mb-2 text-muted">Course</label>
                                        <Select
                                        className='search-select-dropdown'
                                        name="course"
                                        value={course.value!==null?course.value:''}
                                        placeholder='Select Course...'
                                        options={course.options}
                                        isDisabled={detail.is_paid ==1 || !editDetail}
                                        onChange={handleCourseChange}
                                        getOptionLabel={x => x.name}
                                        getOptionValue={x => x.id}
                                        />

                                    </div>
                                    {course.error.length>0 &&<div className='invalidFeedback'>{course.error}</div>}
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <div className="form-floatings">
                                        <label className="text-muted">Admission Mode</label>
                                        <Select
                                        className='search-select-dropdown'
                                        name="course"
                                        value={admissionMode.value!==undefined &&admissionMode.value!==null?admissionMode.value:''}
                                        placeholder='Select Admission Mode'
                                        options={admissionMode.options}
                                        // isDisabled={detail.is_paid ==1 || !editDetail}
                                        isDisabled={true}
                                        onChange={handleAdmissionModeChange}
                                        getOptionLabel={x => x.name}
                                        getOptionValue={x => x.id}
                                        />
                                    </div>
                                    {admissionMode.error.length>0 &&<div className='invalidFeedback'>{admissionMode.error}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className='d-flex'>
                                    <div className="form-floating country_codeField d-inline px-2 ps-0">
                                        <input type="text"
                                            className="form-control"
                                            id="floatingInput" placeholder="country code "
                                            value={countryCode.value!==null?countryCode.value:''}
                                            disabled
                                            onChange={(e) => setCountryCode({ ...countryCode, value: e.target.value })} />
                                        <label className='optional'>Country code</label>
                                    </div>
                                    <div className="form-floating d-inline w-100">
                                        <input type="number"
                                            className="form-control"
                                            id="floatingInput" placeholder="Mobile"
                                            value={mobileNumber.value!==null?mobileNumber.value:''}
                                            disabled={detail.is_paid ==1 || !editDetail }
                                            maxLength="16"
                                            onChange={(e) => setMobile({ ...mobileNumber, value: e.target.value, error: '' })} />
                                        <label>Mobile</label>
                                    </div>
                                </div>
                                {mobileNumber.error.length > 0 && <div className='invalidFeedback'>{mobileNumber.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" disabled name="email" placeholder="Email"
                                        value={email.value!==null?email.value:''} onChange={(e) => setEmail({ ...email, value: e.target.value, error: '' })}
                                    />
                                    <label>Email Address</label>
                                </div>
                                {email.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{email.error}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floatings diff_disable">
                                <label className="mb-2 ">Curriculums</label>
                                    <Select
                                        className='search-select-dropdown'
                                        name="curriculums"
                                        value={curriculums.value!==null ?curriculums.value:''}
                                        placeholder='Select Curriculums'
                                        options={curriculums.options}
                                        isDisabled={!editDetail}
                                        onChange={handleCurriculumChange}
                                        getOptionLabel={x => x.name}
                                        getOptionValue={x => x.id}
                                    />
                                </div>
                                {curriculums.error.length > 0 && <div className='invalidFeedback'>{curriculums.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floatings">
                                <label className="mb-2 text-muted">School</label>
                                    <Select
                                        className='search-select-dropdown'
                                        name="schools"
                                        value={schools.value!==null?schools.value:''}
                                        placeholder='Select school'
                                        options={schools.options}
                                        isDisabled={!editDetail }
                                        onChange={handleSchoolChange}
                                        getOptionLabel={x => x.name}
                                        getOptionValue={x => x.id}
                                    />
                                </div>
                                {schools.error.length > 0 && <div className='invalidFeedback'>{schools.error}</div>}
                            </div>
                            {isOtherSchool || schools.value == 0 ? 
                            <div className="col-lg-12 mb-3">
                                <div className="form-floating diff_disable">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="otherSchoolName"
                                        placeholder="Other School Name"
                                        value={otherSchoolName.value!==null?otherSchoolName.value:'' }
                                        disabled={!isOtherSchool || !editDetail}
                                        onChange={(e) => setOtherSchoolName({ ...otherSchoolName, value: e.target.value, error: '' })}
                                    />
                                    <label className={!isOtherSchool ? 'optional':''}>Other School Name</label>
                                </div>
                                {otherSchoolName.error.length > 0 && <div className='invalidFeedback'>{otherSchoolName.error}</div>}
                            </div>
                            :''}

                            {/* Admit card field */}
                            {/* {course.value?.category_id ===3 && (
                            <div className="col-lg-12 mb-3">
                                <div className="form-floating">
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="admitcard"
                                        accept=".png, .jpg, .jpeg, .pdf"
                                        value={''}
                                        onChange={handleFileChange}
                                    />
                                    <label>Upload Admit card</label>
                                </div>
                                {admitCard.error.length > 0 && <div className='invalidFeedback'>{admitCard.error}</div>}
                            </div>
                            )} */}
                            
                            <div className='w-100'></div>
                            {editDetail ? <div className="col-lg-2">
                              
                                {loading ? (<button type="submit" disabled className="btn btn-primary d-inline-block btn-md w-auto auth_btn">
                        <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                        Updating..</button>) :
                          <input type="button" className="btn btn-primary" value="Save" onClick={onSubmit} />
                    }
                             
                            </div>
                                :
                                <div className="col-lg-2">
                                                <input type="button" className="btn btn-primary" value="Edit" onClick={editPersonalDetail} />
                              
                                </div>}

                            {editDetail && <div className="col-lg-2">
                                <input type="button" className="btn btn-primary" value="Cancel" onClick={handleCancel} />
                            </div>}

                        </div>
                    </form>
                </AccordionBody>
            </Accordion>
        </>
    )
}

export default EnrollmentDetail
